// extracted by mini-css-extract-plugin
export var wrapper = "ErrorModal-module--wrapper--a6cbf";
export var text = "ErrorModal-module--text--39e51";
export var contact = "ErrorModal-module--contact--cd8e7";
export var link = "ErrorModal-module--link--28918";
export var icon = "ErrorModal-module--icon--153b7";